import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AccountingDataStandardizationService } from '@services/http/accounting-data-standardization/accounting-data-standardization.service';
import { AiChatAttachmentHttpService } from '@services/http/ai/ai-chat-attachment-http.service';
import { AiChatSessionHttpService } from '@services/http/ai/ai-chat-session-http.service';
import { CompanyService } from '@services/http/company.service';
import { DFPService } from '@services/http/dfp/dfp.service';
import { ReportTemplatePdfHttpService } from '@services/http/vault-doc-generate-report/vault-doc-generate.service';
import { WalterV2HttpService } from '@services/http/walter-ai/walter-ai-v2-http.service';
import { DeParaOverwriteGuardService } from '@services/helpers/de-para-overwrite/de-para-overwrite-guard.service';
import { PdfUtilsServiceV2 } from '@services/helpers/pdf-utils/pdf-utils-v2.service';
import { provideUnscopedCompanyScope } from '@services/helpers/unscoped-company-scope';
import DfpComponent from '@features/dashboard/performance/pages/dfp/dfp.component';
import { DfpExportService } from '@features/dashboard/performance/pages/dfp/services/dfp-export.service';
import { TableExportService } from '@shared/components/table/services/table-export.service';

/**
 * Aba Análise econômica da tela do deal (cards 3268 e 3298): a DFP Histórica da empresa do deal,
 * ignorando o escopo de empresas do usuário TENANT.
 *
 * O deal aparece para o time interno em qualquer escopo (a lista de deals não filtra por empresa), então
 * o conteúdo da aba também não pode filtrar. Os `providers` dão a esta subárvore a versão sem escopo do
 * serviço de escopo e instâncias próprias de cada serviço HTTP usado pela DFP (tabelas, origem do
 * faturamento e conferência da DRE pelo próprio `DFPService`, estado vazio, "Ver De/Para", exportação e o chat do botão de IA). Fora daqui nada muda.
 *
 * ⚠️ Serviço HTTP novo usado dentro da DFP precisa entrar nesta lista, senão aquele pedaço volta a
 * obedecer ao escopo. Ver `provideUnscopedCompanyScope`.
 */
@Component({
  selector: 'app-deal-economic-analysis-tab',
  standalone: true,
  imports: [DfpComponent],
  providers: provideUnscopedCompanyScope([
    DFPService,
    CompanyService,
    AccountingDataStandardizationService,
    DeParaOverwriteGuardService,
    DfpExportService,
    TableExportService,
    PdfUtilsServiceV2,
    ReportTemplatePdfHttpService,
    WalterV2HttpService,
    AiChatSessionHttpService,
    AiChatAttachmentHttpService,
  ]),
  template: `<app-dfp [companyId]="companyId()" [embedded]="true" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealEconomicAnalysisTabComponent {
  readonly companyId = input.required<string>();
}
